import { useState, useCallback } from 'react';
import { useCombinedHandler } from 'js/hooks/useCombinedHandler';
import { useResizeObserver } from 'js/hooks/useResizeObserver';

import * as helpers from '../helpers';

export const useHeights = ({ lines }) => {
    const [height, setHeight] = useState(null);
    const [compressedHeight, setCompressedHeight] = useState(null);
    const updateHeight = useCallback((entries) => {
        setHeight(helpers.getComputedHeight(entries[0].target));
    }, []);

    const setRefs = [
        useCallback((node) => {
            if (node) {
                setHeight(helpers.getComputedHeight(node));
                setCompressedHeight(`${helpers.getLineHeight(node) * lines}px`);
            }
        }, [lines]),
        useResizeObserver({ callback: updateHeight })
    ];

    return [useCombinedHandler(setRefs), height, compressedHeight];
};
